var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPluginWikipedia({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5H1v1h1.5L8 19h1l2.708-5.417L14 19h1l6.5-13H23V5h-4v1h1l-5 10-2-5 2.5-5H17V5h-4v1h1l-1.667 3.333L11 6h1V5H7v1h1.5l2.52 5.958L9 16 5 6h1V5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPluginWikipedia);
export default __webpack_public_path__ + "static/media/ic_plugin_wikipedia.9504a3cd9d7e5acaef2bce649beeec94.svg";
export { ForwardRef as ReactComponent };